<p-multiSelect
  [options]="items"
  [(ngModel)]="selectedItems"
  appendTo="body"
  placeholder="Izaberite status uplate računa"
  (onChange)="selectedItemsOnChange()"
></p-multiSelect>
